<template>
  <div class="map-box">
    <div id="tip" v-if="useType == 'select'">
      <input type="text" id="keyword" name="keyword" value="请输入关键字：(选定后搜索)" onfocus='this.value=""'/>
    </div>
    <div class="container" ref="container" id="container"></div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      map: ''
    }
  },
  props: ['useType', 'mapPoints', 'trailArr', 'address'],
  mounted() {
    this.$nextTick(() => {
      this.init()
      this.showPointFun()
    })
  },
  methods: {
    init() {
      this.map = new AMap.Map('container', {
        center: [106.550464, 29.563761],
        resizeEnable: true,
        zoom: 13,
        zoomEnable: true,
        dragEnable: true,
      });
      let that = this;
      if (that.useType === 'select') {
        // AMap.plugin(['AMap.Autocomplete','AMap.PlaceSearch'],function(){
          var autoOptions = {
            city: "全国", //城市，默认全国
            input: "keyword"//使用联想输入的input的id
          };
          let autocomplete= new AMap.Autocomplete(autoOptions);
          console.log(autocomplete,'autocomplete')
          var placeSearch = new AMap.PlaceSearch({
            city:'重庆',
            map: that.map
          })
          console.log(placeSearch)
          AMap.event.addListener(autocomplete, "select", function(e){
            //TODO 针对选中的poi实现自己的功能
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name)
          });
        // });

        this.map.on('click', function (ev) {
          let lnglat = [ev.lnglat.lng, ev.lnglat.lat];
          let address = '';
          that.infoWindow(lnglat, address);
        });
      }
      if (this.useType === 'line') {
        AMap.plugin('AMap.TruckDriving', function () {
          const truckOptions = {
            map: that.map,
            policy: 0,
            size: 1,
            city:'chongqing',
          };
          const driving = new AMap.TruckDriving(truckOptions);
          driving.search(that.mapPoints, function (status, result) {
            if (status !== 'complete') {
              // that.$message.error('获取货车规划数据失败：' + result.info);
              console.error(result)
            }
          });
        });
      }
      if (that.useType === 'view') {
        for (let item of this.mapPoints) {
          that.infoWindow(item.position.split(','), item.keyword, false);
        }
      }
      if(that.useType === 'polyline') {
        //展示轨迹
        if(this.trailArr.length) {
          this.map.setCenter(this.trailArr[0])
          let arr = this.trailArr.slice(0)
          let marker = new AMap.Marker({
            map: that.map,
            position: that.trailArr[0],
            icon: "https://webapi.amap.com/images/car.png",
            offset: new AMap.Pixel(-26, -13),
            autoRotation: true,
            angle:-90,
          })
          // 绘制轨迹
          let polyline = new AMap.Polyline({
            map: that.map,
            path: arr,
            showDir:true,
            strokeColor: "#28F",  //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6,      //线宽
            // strokeStyle: "solid"  //线样式
          })

          let passedPolyline = new AMap.Polyline({
            map: that.map,
            // path: lineArr,
            strokeColor: "#AF5",  //线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6,      //线宽
            // strokeStyle: "solid"  //线样式
          })

          that.map.setFitView()
          marker.moveAlong(arr, 200)
        }else{
          // this.$message.warning('暂无轨迹信息')
        }
      }
      if(that.useType === 'point') {
        this.showPointFun()
      }
    },
    infoWindow(lnglat, address, visible = true) {
      let that = this;
      AMap.plugin('AMap.Geocoder', function () {
        let geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        });
        geocoder.getAddress(lnglat, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            let area='';
            console.log(result,'result')
            if (result.regeocode.addressComponent.city) area = result.regeocode.addressComponent.province+'-'+result.regeocode.addressComponent.city+'-'+result.regeocode.addressComponent.district;
            else area = result.regeocode.addressComponent.province+'-'+result.regeocode.addressComponent.district;
            address = result.regeocode.formattedAddress;
            // 创建盒子
            let box = document.createElement('div');
            // 设置样式
            box.className = 'select-map';
            box.innerHTML = `
                 <!--<div class="title">当前地点</div>-->
                 <div>地点：${address}</div>
                 <div>当前经度：${lnglat[0]}</div>
                 <div>当前维度：${lnglat[1]}</div>
                 `;
            /*// 创建图标
             let icon = document.createElement('i');
             icon.className = 'el-icon-close';
             icon.onclick = () => {
             that.closeInfoWindow();
             };
             box.appendChild(icon);*/

            // 创建按钮盒子
            let butBox = document.createElement('div');
            butBox.className = "but";
            // 创建按钮
            let but = document.createElement('input');
            but.type = 'button';
            but.value = '确定';
            but.onclick = () => {
              that.$emit('close', address, lnglat,area,result.regeocode.addressComponent.adcode)
            };
            // 创建按钮
            let but1 = document.createElement('input');
            but1.type = 'button';
            but1.value = '取消';
            but1.onclick = () => {
              that.closeInfoWindow();
            };

            butBox.appendChild(but);
            butBox.appendChild(but1);
            visible && box.appendChild(butBox);
            //实例化信息窗体
            var infoWindow = new AMap.InfoWindow({
              position: lnglat,
              isCustom: false,  //使用自定义窗体
              content: box,
            });
            // var infoWindow = new AMap.InfoWindow({
            //     position: lnglat,
            //     offset: new AMap.Pixel(0, -35),
            //     content: infoWindowContent
            // });

            // 打开信息窗体
            infoWindow.open(that.map, lnglat);
          }
        })
      })
    },
    // 关闭信息窗体
    closeInfoWindow(){
      this.map.clearInfoWindow();
    },

    showPointFun() {
      let that = this
      AMap.plugin('AMap.Geocoder', function() {
        let geocoder = new AMap.Geocoder({
          city: 'chongqing'
        })
        geocoder.getLocation(that.address, function(status, result) {
          if (status === 'complete' && result.geocodes.length) {

            let lnglat = result.geocodes[0].location
            let marker = new AMap.Marker()
            marker.setPosition(lnglat)
            that.map.add(marker)

            that.map.setFitView(marker)
            that.map.setZoomAndCenter(15, lnglat)

            let infoWindow = new AMap.InfoWindow({
              content: that.address,
              offset: new AMap.Pixel(0, -30)
            })
            infoWindow.open(that.map, lnglat)

            //鼠标点击marker弹出自定义的信息窗体
            AMap.event.addListener(marker, 'click', function () {
              infoWindow.open(that.map, marker.getPosition());
            })
          }else{
            // this.$message.warning('根据地址查询位置失败')
          }
        })
      })
    },

    back() {
      this.$emit('close', null)
    },
  }
}
</script>

<style lang="scss" scoped>
.map-box {
  width: 100%;
  height: 100%;
  position: relative;
  #tip{
    background-color: #ddf;
    color: #333;
    border: 1px solid silver;
    box-shadow: 3px 4px 3px 0px silver;
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 5px;
    overflow: hidden;
    line-height: 20px;
    z-index: 1000;
  }
  #tip input[type="text"] {
    height: 25px;
    border: 0;
    padding-left: 5px;
    width: 280px;
    border-radius: 3px;
    outline: none;
  }
  .container {
    width: 100%;
    height: 600px;
  }
  .back {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 100;
  }
}
</style>
